module.exports = __webpack_public_path__ + "static/media/canada_day (8 of 2).bed07fb7.jpg";